<script setup lang="ts">
import type {ArticleAsset} from '@/types';
import {HomeFeature, HomeFeatureTile, HomeFeatureContent, HomeFeatureContentLogo, HomeFeatureContentBody} from '@/lib/ui/home-feature';

const {translate} = useTranslation();
// const {fetchAssetBySlug} = useCmsStore();
const data = ref();
// const resp = await fetchAssetBySlug<ArticleAsset>('times-travel-vip-experience');
// if (!resp.error) {
//   data.value = resp;
// }

if (import.meta.client) {
  const {data: lazyResp, error} = await useLazyFetch<ArticleAsset>(`/api/asset-by-slug?slug=times-travel-vip-experience&status=${window ? (window.location !== window.parent.location ? 'draft' : 'published') : 'published'}`, {server: false});

  if (lazyResp.value && !error) {
    data.value = lazyResp.value as ArticleAsset;
  }

  watch(lazyResp, (article: ArticleAsset) => {
    data.value = article;
  });
}
</script>

<template>
  <HomeFeature class="bg-[var(--crystal-vip-color-lighter)] reverse-on-mobile">
    <template v-if="data">
      <HomeFeatureContent class="bg-[url('/assets/crystal-vip/tt-vip-logo-bground.svg')] bg-no-repeat bg-size-[auto_100%]">
        <HomeFeatureContentLogo class="text-left">
          <img :src="data.fields.feature_icon.public_url" alt="NYE Ball Logo" />
        </HomeFeatureContentLogo>

        <HomeFeatureContentBody>
          <h3 class="text-white" v-html="translate(data.fields.sub_title)" />

          <div class="flex flex-col gap-[3rem] !text-white" v-html="translate(data.fields.content)" />

          <ul class="flex gap-[1.5rem]">
            <li>
              <TheButton tag="NuxtLink" class="!border-none !bg-[var(--crystal-vip-color-darker)] !py-4 w-[270px] hover:!bg-black hover:!text-white" to="/nye-ball-crystal-vip-experience#buy-tickets" aria-label="Buy tickets for Times Travel VIP">{{ translate(data.fields.cta_1_label) }}</TheButton>
            </li>
            <li>
              <TheButton tag="NuxtLink" class="!border-none !bg-[var(--crystal-vip-color-darker)] !py-4 w-[270px] hover:!bg-black hover:!text-white" to="/nye-ball-crystal-vip-experience" aria-label="Learn more Times Travel VIP">{{ translate(data.fields.cta_2_label) }}</TheButton>
            </li>
          </ul>
        </HomeFeatureContentBody>
      </HomeFeatureContent>

      <HomeFeatureTile>
        <img :src="data.fields.feature_image.public_url" alt="NYE Ball Feature Tile" />

        <img v-gsap.whenVisible.once.reversible.from="{opacity: 0, y: '20%'}" :src="data.fields.feature_icon.public_url" alt="NYE Ball Logo" class="mobile-only" />
      </HomeFeatureTile>
    </template>
  </HomeFeature>
</template>
